import React, { useState, useRef } from 'react';
import useScrollAnimation from './UseScrollAnimation';
import { useNavigate } from 'react-router-dom';

const Maquina = () => {
  useScrollAnimation();
  const navigate = useNavigate();
  
  // Estado para controlar o som
  const [isMuted, setIsMuted] = useState(true);
  const videoRef = useRef(null);

  const toggleMute = () => {
    if (videoRef.current) {
      videoRef.current.muted = !videoRef.current.muted;
      setIsMuted(videoRef.current.muted);
    }
  };

  return (
    <section className="bg-usifresa-dark py-24 overflow-hidden text-white reveal border-t border-white/5">
      <div className="container mx-auto px-6 md:px-12">
        <div className="flex flex-col lg:flex-row items-center gap-16">
          
          <div className="w-full lg:w-1/2">
            <div className="flex items-center gap-4 mb-6">
              <span className="w-12 h-[3px] bg-usifresa-orange"></span>
              <span className="text-xs md:text-sm font-black text-usifresa-light-blue uppercase tracking-[0.3em]">
                Nossa Indústria
              </span>
            </div>

            <h2 className="font-sans text-[2rem] md:text-5xl lg:text-6xl text-white mb-6 leading-[1.1] font-black tracking-tight uppercase">
              Equipamentos que <br className="hidden md:block"/>
              elevam seu <br className="hidden md:block"/>
              desempenho
            </h2>
            
            <div className="h-1.5 bg-usifresa-orange mb-8 w-full rounded-full"></div>
            
            <p className="text-[15px] md:text-lg text-white/70 leading-relaxed mb-8 font-light">
              A Usifresa dispõe de uma assistência técnica eficaz, com grande estoque de peças de reposição, uma loja virtual onde o cliente pode fazer seus pedidos de peças e uma central telefônica para solicitar um técnico, tirar dúvidas e executar reparos nos equipamentos.
            </p>
            
            <div className="space-y-6 md:space-y-4 w-full">
              <p className="text-xl font-bold text-white uppercase tracking-widest">Saiba mais</p>
              <div className="flex flex-col sm:flex-row gap-4 w-full">
                <button 
                  onClick={() => navigate('/contato')}
                  className="w-full sm:w-auto font-bold bg-usifresa-light-blue text-usifresa-dark hover:bg-white hover:text-usifresa-dark py-4 px-10 rounded-full uppercase tracking-widest text-[11px] md:text-xs transition-all duration-300 shadow-[0_0_20px_rgba(0,195,255,0.2)] hover:shadow-[0_0_30px_rgba(255,255,255,0.4)] flex items-center justify-center"
                >
                  Entre em contato
                </button>
                <button 
                  onClick={() => window.open('https://loja.usifresa.com.br/', '_blank')}
                  className="w-full sm:w-auto font-bold bg-transparent border border-white/20 text-white hover:bg-white hover:text-usifresa-dark py-4 px-10 rounded-full uppercase tracking-widest text-[11px] md:text-xs transition-all duration-300 flex items-center justify-center"
                >
                  Visite a Loja
                </button>
              </div>
            </div>
          </div>

          {/* Lado Direito - Vídeo com controle de som */}
          <div className="w-full lg:w-1/2">
            <div className="relative rounded-[2rem] overflow-hidden w-full border border-white/10 shadow-2xl group">
              <video
                ref={videoRef}
                src="E-commerce Site Usifresa.mp4"
                className="w-full h-[400px] md:h-[500px] lg:h-[600px] object-cover transition-transform duration-700 group-hover:scale-105"
                autoPlay
                loop
                muted={isMuted}
                playsInline
              />
              
              {/* Botão de Controle de Som */}
              <button 
                onClick={toggleMute}
                className="absolute bottom-6 right-6 z-30 bg-black/50 hover:bg-black/70 p-3 rounded-full text-white backdrop-blur-md transition-all"
              >
                {isMuted ? (
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5.586 15H4a1 1 0 01-1-1v-4a1 1 0 011-1h1.586l4.707-4.707C10.923 3.663 12 4.109 12 5v14c0 .891-1.077 1.337-1.707.707L5.586 15zM17 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2"/></svg>
                ) : (
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.536 8.464a5 5 0 010 7.072M18.364 5.636a9 9 0 010 12.728M12 5v14l-4.707-4.707H4a1 1 0 01-1-1v-4a1 1 0 011-1h3.293L12 5z"/></svg>
                )}
              </button>

              <div className="absolute inset-0 bg-gradient-to-t from-usifresa-dark/80 via-transparent to-transparent pointer-events-none"></div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default Maquina;